import { React, useContext, useState } from "react";
import { Link } from "react-router-dom";
import { DotsHorizontalIcon } from "@heroicons/react/solid";
import "./meetup.css";
import moment from "moment";
import axios from "axios";
import swal from "sweetalert";
import ReactShowMoreText from "react-show-more-text";
import { Markup } from "interweave";
import noImage from "../../Assets/Images/settings/no-image.png";

import PostReaction from "../../Screen/Post/PostReaction";
import { serverInfo } from "../../App";

export default function QnaContent({ post }) {


  const { imageCdnUrl } = useContext(serverInfo);
  let todayDate = new Date();
  let endDate = new Date(moment(post?.registration_end_date));



  const [open, setOpen] = useState(false);

  const [data, setData] = useState({
    likes: post.react_number,
    updated: false,
  });

  const handleSubmit = (id) => {
    //e.preventDefault();
    if (!data.updated) {
      setData({ likes: data.likes + 1, updated: true });
    } else {
      setData({ likes: data.likes - 1, updated: false });
    }

    axios.get(`/api/submit_react/${id}`).then((res) => {
      if (res.data.status === 200) {
      } else {
        swal("Warning", "failed", "warning");
      }
    });
  };

  return (
    <>
      <div className="container PostWidth align-items-center justify-content-center col-11 Enroll-Auditions">
        <div className="card PostCardBg ">
          <h2 className="accordion-header PostBack">
            <div className="d-flex justify-content-between">
              <div className="accordion-button-fx profile1-accordion-button PostBack  collapsed">
                <img
                  src={
                    post.star.image !== null
                      ? imageCdnUrl + post.star.image
                      : noImage
                  }
                  className="PostImgHome"
                  alt="star-profile"
                />
                <span className="mx-2 text-warning text-light">
                  <Link
                    to={`/starprofile/${post.user_id}`}
                    className="link-starPorfile"
                  >
                    {post.star.first_name} {post.star.last_name}
                  </Link>
                  <br></br>
                  <small className="category-size-chat">
                    {moment(post.created_at).format("LT")}
                    {" | "}
                  </small>
                  <small className="category-size-chat">
                    {moment(post.created_at).format("LL")}
                  </small>
                </span>
              </div>
            </div>
          </h2>

          <h5 className="my-2 Enroll-a Enroll-text text-justify ">
            {post?.title}
          </h5>

          <ReactShowMoreText
            lines={3}
            more={<span>See more</span>}
            less={<span>See less</span>}
            className="content-css my-2 Enroll-a Enroll-text py-2"
            anchorClass="my-anchor-css-class"
            //onClick={executeOnClick}
            expanded={false}
            truncatedEndingComponent={"... "}
          >
            <Markup content={post.details}></Markup>
          </ReactShowMoreText>

          {/* <ReactReadMoreReadLess charLimit={200} readMoreText={"Read more ▼"} readLessText={"Read less ▲"}
                readMoreClassName="text-white" readLessClassName="text-white">
                {post.meetup.description.replace(regex, "")}
            </ReactReadMoreReadLess> */}
          <div className="ViewPost">
            <div className=" card  border-0 containerPost">
              <img
                src={imageCdnUrl + post?.banner}
                alt="No Banner"
              />

              <div className="centeredPost ">
                <div className="LeftTextPost col-md-8">
                  <div className=" text-light bottom-LeftPost text-start  fw-bold px-4 py-1">
                    Q&A
                  </div>
                </div>
                <div className="LeftTextPost col-md-4">
                {endDate.getTime() >= todayDate.getTime() &&(
                  <Link
                    to={`/qna/details/${post?.event_id}`}
                    className="link-starPorfile"
                  >
                    {" "}
                    <button className="bottom-rightPost text-dark fw-bold AnimateBtn px-4 py-1">
                      <span className="pTd">Book Now</span>
                    </button>
                  </Link>
                )}
                </div>
              </div>
              <div className="centeredPostV "></div>
            </div>

            <PostReaction post={post} />
          </div>
        </div>
      </div>
    </>
  );
}
